import RadioButtonQuest from "../../../../UI/RadioButtonQuest";

const StuckInOverdraft = ({
  onSelectAnswer,
  backClick,
  removeFromPending,
  removeFromPendingFollowup,
  clsName,
}) => {
  const optionClicked = async (e) => {
    if (e.target.value == "293") {
      removeFromPending("howStuckAffects");
    }
    onSelectAnswer(e);
  };

  return (
    <>
      <div className={`qsSlider slidea9 ${clsName}`}>
        <h2 className="qs-title slide-up-now">
          {" "}
          I was stuck in my overdraft and didn't see a positive balance - do you
          agree???
        </h2>
        <div className="btn-option optinal-items optinal-items-payment slide-up-now  ">
          <div className=" option_but mb-3">
            <RadioButtonQuest
              key="stuck1"
              className="radio"
              labelName="Always"
              labelClassName="align-items-center next9"
              onClick={optionClicked}
              value="290"
              name="stuckInOverdraft"
              id="stuck1"
              dataQuestId={105}
              dataAnsId={290}
              dataAnsLabel="Always"
            />
          </div>
          <div className=" option_but mb-3">
            <RadioButtonQuest
              key="stuck2"
              className="radio"
              labelName="Sometimes"
              labelClassName="align-items-center next9"
              onClick={optionClicked}
              value="291"
              name="stuckInOverdraft"
              id="stuck2"
              dataQuestId={105}
              dataAnsId={291}
              dataAnsLabel="Sometimes"
            />
          </div>
          <div className=" option_but mb-3">
            <RadioButtonQuest
              key="stuck3"
              className="radio"
              labelName="Rarely"
              labelClassName="align-items-center next9"
              onClick={optionClicked}
              value="292"
              name="stuckInOverdraft"
              id="stuck3"
              dataQuestId={105}
              dataAnsId={292}
              dataAnsLabel="Rarely"
            />
          </div>
          <div className=" option_but mb-3">
            <RadioButtonQuest
              key="stuck4"
              className="radio"
              labelName="Never"
              labelClassName="align-items-center next9"
              onClick={optionClicked}
              value="293"
              name="stuckInOverdraft"
              id="stuck4"
              dataQuestId={105}
              dataAnsId={293}
              dataAnsLabel="Never"
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default StuckInOverdraft;
